import React from 'react';
import { CalendarDays } from 'lucide-react';

interface DatePickerProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: string;
  error?: string;
  helperText?: React.ReactNode;
  controllerSize?: 'sm' | 'md';
}

const DatePicker = React.forwardRef<HTMLInputElement, DatePickerProps>(
  (
    {
      label,
      error,
      helperText,
      controllerSize = 'md',
      className = '',
      ...props
    },
    ref,
  ) => {
    const sizeClass = controllerSize === 'sm' ? 'px-3 py-1.5 text-base' : 'px-3 py-2';

    return (
      <div className="space-y-1">
        {label && (
          <label className="block text-sm text-gray-700 dark:text-gray-300">
            {label}
          </label>
        )}
        <div className="relative">
          <input
            ref={ref}
            type="date"
            className={`
              w-full border border-gray-300 rounded-md shadow-sm
              focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500
              disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
              bg-white pr-10 dark:bg-gray-900 dark:border-gray-600 dark:text-white
              [&::-webkit-calendar-picker-indicator]:absolute
              [&::-webkit-calendar-picker-indicator]:right-3
              [&::-webkit-calendar-picker-indicator]:w-5
              [&::-webkit-calendar-picker-indicator]:h-5
              [&::-webkit-calendar-picker-indicator]:opacity-0
              [&::-webkit-calendar-picker-indicator]:cursor-pointer
              ${sizeClass}
              ${error ? 'border-red-300 focus:ring-red-500 focus:border-red-500' : ''}
              ${className}
            `}
            {...props}
          />
          <CalendarDays
            size={16}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
          />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        {helperText && !error && <p className="text-sm text-gray-500">{helperText}</p>}
      </div>
    );
  },
);

DatePicker.displayName = 'DatePicker';

export default DatePicker;

